import type { SVGProps } from 'react';
import type React from 'react';

export function MarketingIconStack(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 112 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_11_3874)">
        <g clipPath="url(#clip0_11_3874)">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 5.30292 25.7529)"
            fill="white"
          />
          <path
            d="M18.8543 8.40527V19.8753L21.7946 17.5356V9.99717L18.8543 8.40527Z"
            fill="#5C4C9F"
          />
          <path
            d="M17.4899 17.3706L15.1155 18.4028V9.39819L17.4899 10.1025V17.3706Z"
            fill="#5C4C9F"
          />
          <path
            d="M11.9425 17.1039L13.7511 16.6315L13.7525 10.8794L11.9439 10.5935L11.9425 17.1039Z"
            fill="#5C4C9F"
          />
          <g style={{ mixBlendMode: 'color' }} filter="url(#filter1_d_11_3874)">
            <rect
              width="23.5043"
              height="23.5043"
              rx="11.7522"
              transform="matrix(1 0 0 -1 5.35565 25.7529)"
              fill="white"
            />
            <rect
              x="0.489673"
              y="-0.489673"
              width="22.525"
              height="22.525"
              rx="11.2625"
              transform="matrix(1 0 0 -1 5.35565 24.7736)"
              stroke="#DDDDE0"
              strokeWidth="0.979346"
            />
          </g>
        </g>
        <rect
          x="0.489673"
          y="-0.489673"
          width="22.525"
          height="22.525"
          rx="11.2625"
          transform="matrix(1 0 0 -1 5.30292 24.7736)"
          stroke="#DDDDE0"
          strokeWidth="0.979346"
        />
      </g>
      <g filter="url(#filter2_d_11_3874)">
        <g clipPath="url(#clip1_11_3874)">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 31.4188 25.7529)"
            fill="white"
          />
          <path
            d="M41.197 10.1072C41.3079 9.81619 41.4603 9.54827 41.6867 9.33116C42.5921 8.44887 44.0887 8.67059 44.7031 9.77923C45.165 10.62 45.6547 11.4422 46.1305 12.2737C46.925 13.6548 47.7288 15.036 48.514 16.4218C49.1746 17.5813 48.4586 19.0456 47.1467 19.2442C46.343 19.3644 45.59 18.9948 45.1743 18.2742C44.4768 17.0593 43.7746 15.8444 43.0771 14.6342C43.0632 14.6064 43.0448 14.5833 43.0263 14.5602C42.9524 14.5002 42.92 14.4124 42.8739 14.3339C42.5644 13.7888 42.2456 13.2483 41.9361 12.7079C41.7375 12.3568 41.5296 12.0104 41.331 11.6593C41.1508 11.3452 41.0677 11.0034 41.0769 10.643C41.0908 10.4583 41.1139 10.2735 41.197 10.1072Z"
            fill="#3C8BD9"
          />
          <path
            d="M41.1971 10.1072C41.1555 10.2735 41.1185 10.4398 41.1093 10.6153C41.0955 11.0033 41.1924 11.3636 41.3865 11.7008C41.8946 12.5739 42.4027 13.4516 42.9062 14.3292C42.9524 14.4078 42.9894 14.4863 43.0356 14.5602C42.7584 15.0406 42.4813 15.5164 42.1995 15.9968C41.8114 16.6666 41.4234 17.341 41.0308 18.0109C41.0123 18.0109 41.0077 18.0016 41.0031 17.9878C40.9984 17.9508 41.0123 17.9185 41.0215 17.8815C41.2109 17.1886 41.0539 16.5742 40.5781 16.0476C40.2871 15.7289 39.9175 15.5487 39.4925 15.4887C38.9382 15.4102 38.4486 15.5534 38.0097 15.8998C37.9312 15.9599 37.8804 16.0476 37.788 16.0938C37.7695 16.0938 37.7603 16.0846 37.7557 16.0707C37.9774 15.6873 38.1945 15.3039 38.4162 14.9205C39.3309 13.3315 40.2455 11.7424 41.1648 10.158C41.174 10.1395 41.1879 10.1257 41.1971 10.1072Z"
            fill="#FABC04"
          />
          <path
            d="M37.7741 16.0847C37.8619 16.0062 37.945 15.923 38.0374 15.8491C39.1599 14.9622 40.846 15.6042 41.0908 17.0085C41.1509 17.3457 41.1185 17.6691 41.0169 17.9925C41.0123 18.0202 41.0077 18.0433 40.9984 18.071C40.9568 18.1449 40.9199 18.2234 40.8737 18.2973C40.4626 18.9764 39.8574 19.3136 39.0629 19.2628C38.1529 19.1981 37.4369 18.5144 37.3122 17.6091C37.2521 17.1702 37.3399 16.7591 37.5663 16.3803C37.6125 16.2972 37.6679 16.2232 37.7187 16.1401C37.7418 16.1216 37.7326 16.0847 37.7741 16.0847Z"
            fill="#34A852"
          />
          <path
            d="M37.7741 16.0846C37.7556 16.1031 37.7556 16.1354 37.7233 16.1401C37.7187 16.1077 37.7372 16.0893 37.7556 16.0662L37.7741 16.0846Z"
            fill="#FABC04"
          />
          <path
            d="M40.9984 18.071C40.98 18.0386 40.9984 18.0155 41.0169 17.9924C41.0215 17.9971 41.0308 18.0063 41.0354 18.0109L40.9984 18.071Z"
            fill="#E1C025"
          />
          <g style={{ mixBlendMode: 'color' }} filter="url(#filter3_d_11_3874)">
            <rect
              width="23.5043"
              height="23.5043"
              rx="11.7522"
              transform="matrix(1 0 0 -1 31.4734 25.7529)"
              fill="white"
            />
            <rect
              x="0.489673"
              y="-0.489673"
              width="22.525"
              height="22.525"
              rx="11.2625"
              transform="matrix(1 0 0 -1 31.4734 24.7736)"
              stroke="#DDDDE0"
              strokeWidth="0.979346"
            />
          </g>
        </g>
        <rect
          x="0.489673"
          y="-0.489673"
          width="22.525"
          height="22.525"
          rx="11.2625"
          transform="matrix(1 0 0 -1 31.4188 24.7736)"
          stroke="#DDDDE0"
          strokeWidth="0.979346"
        />
      </g>
      <g filter="url(#filter4_d_11_3874)">
        <g clipPath="url(#clip2_11_3874)">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 57.5347 25.7529)"
            fill="white"
          />
          <path
            d="M74.8798 14.1403C74.8798 10.9732 72.3119 8.40527 69.1448 8.40527C65.9776 8.40527 63.4097 10.9732 63.4097 14.1403C63.4097 17.0026 65.5066 19.3753 68.2487 19.806V15.7985H66.7922V14.1403H68.2487V12.8765C68.2487 11.4393 69.1052 10.6449 70.415 10.6449C71.0424 10.6449 71.6989 10.757 71.6989 10.757V12.1684H70.9755C70.2634 12.1684 70.0408 12.6104 70.0408 13.0644V14.1403H71.6312L71.3771 15.7985H70.0408V19.806C72.7829 19.3761 74.8798 17.0034 74.8798 14.1403Z"
            fill="#1877F2"
          />
          <path
            d="M71.3771 15.7986L71.6312 14.1404H70.0408V13.0645C70.0408 12.6113 70.2625 12.1685 70.9755 12.1685H71.6989V10.7571C71.6989 10.7571 71.0424 10.645 70.415 10.645C69.1052 10.645 68.2487 11.4386 68.2487 12.8766V14.1404H66.7922V15.7986H68.2487V19.8061C68.5407 19.852 68.8399 19.8754 69.1447 19.8754C69.4496 19.8754 69.7488 19.8512 70.0408 19.8061V15.7986H71.3771Z"
            fill="white"
          />
          <g style={{ mixBlendMode: 'color' }} filter="url(#filter5_d_11_3874)">
            <rect
              width="23.5043"
              height="23.5043"
              rx="11.7522"
              transform="matrix(1 0 0 -1 57.5894 25.7529)"
              fill="white"
            />
            <rect
              x="0.489673"
              y="-0.489673"
              width="22.525"
              height="22.525"
              rx="11.2625"
              transform="matrix(1 0 0 -1 57.5894 24.7736)"
              stroke="#DDDDE0"
              strokeWidth="0.979346"
            />
          </g>
        </g>
        <rect
          x="0.489673"
          y="-0.489673"
          width="22.525"
          height="22.525"
          rx="11.2625"
          transform="matrix(1 0 0 -1 57.5347 24.7736)"
          stroke="#DDDDE0"
          strokeWidth="0.979346"
        />
      </g>
      <g filter="url(#filter6_d_11_3874)">
        <g clipPath="url(#clip3_11_3874)">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 83.6506 25.7529)"
            fill="white"
          />
          <path
            d="M94.2449 9.27673C94.461 9.05055 94.7274 8.87855 95.0224 8.7747C95.3175 8.67085 95.6329 8.63808 95.9429 8.67906C96.2531 8.72004 96.5491 8.83361 96.8071 9.01053C97.065 9.18746 97.2776 9.42276 97.4275 9.6973C97.738 9.55836 98.0745 9.4872 98.4147 9.48854C99.0682 9.48854 99.695 9.74815 100.157 10.2103C100.619 10.6724 100.879 11.2992 100.879 11.9527C100.879 12.6062 100.619 13.233 100.157 13.6951C99.695 14.1572 99.0682 14.4168 98.4147 14.4168C98.2533 14.4164 98.0924 14.3997 97.9345 14.3671C97.7792 14.6441 97.553 14.8748 97.2791 15.0355C97.0053 15.1962 96.6936 15.2811 96.3761 15.2817C96.1059 15.283 95.8391 15.221 95.5972 15.1005C95.437 15.4752 95.1682 15.7934 94.8254 16.0138C94.4826 16.2343 94.0816 16.3469 93.6741 16.3372C93.2667 16.3275 92.8715 16.1959 92.5396 15.9593C92.2077 15.7228 91.9543 15.3922 91.8121 15.0102C91.6835 15.0379 91.5522 15.0517 91.4206 15.0515C91.0015 15.0479 90.5953 14.9066 90.2644 14.6495C89.9334 14.3924 89.6962 14.0336 89.5891 13.6285C89.482 13.2233 89.511 12.7942 89.6716 12.4071C89.8322 12.02 90.1156 11.6965 90.4781 11.4862C90.3571 11.209 90.2955 10.9094 90.2973 10.6069C90.2965 10.1467 90.4401 9.6979 90.708 9.32373C90.9758 8.94956 91.3544 8.66891 91.7902 8.52134C92.2261 8.37378 92.6972 8.36675 93.1373 8.50124C93.5774 8.63574 93.9641 8.90498 94.243 9.27099"
            fill="#00A1E0"
          />
          <path
            d="M91.1763 12.5245C91.1739 12.5289 91.1731 12.534 91.1739 12.5389C91.1747 12.5439 91.1772 12.5484 91.1809 12.5517C91.2035 12.5651 91.2218 12.5788 91.244 12.5926C91.3487 12.6473 91.4659 12.6737 91.5839 12.6691C91.8133 12.6691 91.9597 12.5471 91.9597 12.3479V12.3429C91.9597 12.1575 91.7965 12.0937 91.6424 12.044L91.6252 12.0371C91.5105 12.0011 91.4126 11.9694 91.4126 11.8926V11.8876C91.4126 11.8245 91.4719 11.7729 91.5621 11.7729C91.665 11.7741 91.766 11.8004 91.8565 11.8494C91.8587 11.851 91.8612 11.8522 91.8639 11.8528C91.8665 11.8535 91.8693 11.8536 91.872 11.8531C91.8747 11.8527 91.8773 11.8518 91.8796 11.8503C91.8819 11.8489 91.884 11.847 91.8856 11.8448V11.8402C91.8905 11.8264 91.9311 11.7224 91.9311 11.7129C91.9324 11.708 91.9324 11.7028 91.9308 11.698C91.9292 11.6931 91.9263 11.6889 91.9223 11.6857C91.821 11.6256 91.7051 11.5944 91.5873 11.5955H91.5648C91.3522 11.5955 91.2027 11.7224 91.2027 11.9078V11.9128C91.2027 12.1078 91.3656 12.1709 91.52 12.2118L91.5426 12.2206C91.6573 12.2565 91.751 12.2837 91.751 12.3613V12.3659C91.751 12.4389 91.6879 12.4932 91.5881 12.4932C91.4821 12.4941 91.3782 12.4641 91.2891 12.4068C91.2708 12.398 91.2616 12.3884 91.2509 12.3842C91.2464 12.3811 91.2408 12.3799 91.2353 12.3808C91.2299 12.3817 91.225 12.3847 91.2218 12.3892V12.3938L91.1763 12.5245Z"
            fill="white"
          />
          <path
            d="M94.5735 12.5245C94.5711 12.5289 94.5702 12.534 94.5711 12.5389C94.5719 12.5439 94.5744 12.5484 94.5781 12.5517C94.6006 12.5651 94.619 12.5788 94.6416 12.5926C94.7461 12.6473 94.8632 12.6737 94.9811 12.6691C95.2105 12.6691 95.3569 12.5471 95.3569 12.3479V12.3429C95.3569 12.1575 95.194 12.0937 95.0396 12.044L95.0231 12.0371C94.9084 12.0011 94.8105 11.9694 94.8105 11.8926V11.8876C94.8105 11.8245 94.8698 11.7729 94.96 11.7729C95.0629 11.7741 95.1639 11.8004 95.2544 11.8494C95.2566 11.851 95.2591 11.8522 95.2618 11.8528C95.2645 11.8535 95.2672 11.8536 95.2699 11.8531C95.2726 11.8527 95.2752 11.8518 95.2775 11.8503C95.2799 11.8489 95.2819 11.847 95.2835 11.8448V11.8402C95.2885 11.8264 95.329 11.7224 95.329 11.7129C95.3303 11.708 95.3301 11.7028 95.3286 11.698C95.327 11.6932 95.3241 11.6889 95.3202 11.6857C95.2189 11.6256 95.103 11.5944 94.9853 11.5955H94.9627C94.7501 11.5955 94.6006 11.7224 94.6006 11.9078V11.9128C94.6006 12.1078 94.7635 12.1709 94.918 12.2118L94.9405 12.2206C95.0552 12.2565 95.1489 12.2837 95.1489 12.3613V12.3659C95.1489 12.4389 95.0858 12.4932 94.986 12.4932C94.8801 12.4941 94.7762 12.4641 94.6871 12.4068C94.6687 12.398 94.6599 12.3884 94.6488 12.3842C94.6443 12.3811 94.6387 12.3799 94.6333 12.3808C94.6278 12.3817 94.623 12.3847 94.6198 12.3892V12.3938L94.5735 12.5245Z"
            fill="white"
          />
          <path
            d="M97.0938 11.9268C97.0762 11.8657 97.0469 11.8087 97.0074 11.7589C96.9661 11.7108 96.9152 11.6717 96.8579 11.6442C96.7245 11.5899 96.575 11.5899 96.4416 11.6442C96.3844 11.6718 96.3335 11.7108 96.2921 11.7589C96.2508 11.8075 96.2212 11.865 96.2057 11.9268C96.1697 12.0632 96.1697 12.2067 96.2057 12.3432C96.2232 12.4042 96.2526 12.4612 96.2921 12.511C96.3335 12.5591 96.3844 12.5981 96.4416 12.6257C96.575 12.68 96.7245 12.68 96.8579 12.6257C96.9161 12.5997 96.9673 12.5604 97.0074 12.511C97.0487 12.4624 97.0782 12.405 97.0938 12.3432C97.1126 12.2753 97.1217 12.2052 97.121 12.1348C97.1219 12.0643 97.1128 11.994 97.0938 11.926V11.9268ZM96.8988 12.1367C96.9034 12.2286 96.8816 12.3199 96.8358 12.3997C96.8152 12.4308 96.7865 12.4557 96.7528 12.4716C96.7191 12.4875 96.6816 12.4938 96.6446 12.49C96.6077 12.4924 96.5708 12.4854 96.5373 12.4696C96.5039 12.4538 96.475 12.4298 96.4534 12.3997C96.4118 12.3184 96.3901 12.2284 96.3901 12.1371C96.3901 12.0457 96.4118 11.9557 96.4534 11.8744C96.474 11.8433 96.5026 11.8184 96.5363 11.8024C96.57 11.7864 96.6075 11.78 96.6446 11.7838C96.6815 11.7813 96.7185 11.7884 96.7519 11.8042C96.7854 11.8201 96.8142 11.8443 96.8358 11.8744C96.8821 11.9538 96.904 12.045 96.8988 12.1367Z"
            fill="white"
          />
          <path
            d="M98.685 12.4615C98.6845 12.4592 98.6835 12.457 98.6822 12.455C98.6808 12.4531 98.6791 12.4514 98.6771 12.4501C98.6751 12.4489 98.6729 12.448 98.6706 12.4476C98.6683 12.4472 98.6659 12.4472 98.6636 12.4477C98.6342 12.4594 98.6039 12.4685 98.5729 12.4748C98.5385 12.4803 98.5038 12.4832 98.4689 12.4836C98.4283 12.486 98.3876 12.48 98.3494 12.466C98.3112 12.452 98.2763 12.4303 98.2468 12.4022C98.1856 12.3271 98.1564 12.231 98.1654 12.1346C98.1618 12.0445 98.1873 11.9556 98.238 11.8811C98.2636 11.8485 98.2969 11.8228 98.3348 11.8063C98.3728 11.7898 98.4143 11.783 98.4556 11.7866C98.5245 11.7855 98.5932 11.7947 98.6593 11.8138C98.6641 11.8146 98.6691 11.8136 98.6732 11.8111C98.6773 11.8086 98.6804 11.8046 98.6819 11.8C98.6999 11.7545 98.7136 11.7186 98.7312 11.6689C98.7326 11.6643 98.732 11.6593 98.7297 11.6551C98.7274 11.6509 98.7236 11.6477 98.719 11.6463C98.6764 11.6317 98.6325 11.6211 98.5879 11.6146C98.5399 11.6088 98.4917 11.6059 98.4433 11.6058C98.369 11.6045 98.2951 11.6183 98.2262 11.6463C98.1656 11.6724 98.1115 11.7115 98.0679 11.761C98.0256 11.8103 97.9932 11.8673 97.9727 11.9289C97.9502 11.9961 97.9394 12.0667 97.9406 12.1376C97.9344 12.2774 97.9797 12.4145 98.0679 12.523C98.1178 12.5736 98.1781 12.6127 98.2447 12.6377C98.3112 12.6626 98.3824 12.6728 98.4533 12.6675C98.5477 12.6687 98.6416 12.6518 98.7297 12.6178C98.7333 12.6155 98.736 12.6121 98.7375 12.6081C98.7391 12.6042 98.7394 12.5998 98.7385 12.5956L98.685 12.4615Z"
            fill="white"
          />
          <path
            d="M99.6761 11.8908C99.6591 11.8341 99.6297 11.7819 99.5901 11.7379C99.5559 11.6956 99.5123 11.662 99.4628 11.6396C99.4021 11.615 99.3371 11.6028 99.2716 11.6037C99.197 11.6019 99.1229 11.6158 99.0541 11.6446C98.9962 11.6709 98.945 11.7102 98.9046 11.7593C98.8638 11.8104 98.8331 11.8688 98.8139 11.9313C98.7956 11.9994 98.7865 12.0696 98.7868 12.1401C98.7854 12.211 98.7963 12.2816 98.8189 12.3489C98.8358 12.412 98.8685 12.4698 98.9141 12.5167C98.961 12.563 99.0163 12.5998 99.077 12.6252C99.1534 12.6547 99.2354 12.667 99.3171 12.6612C99.4309 12.668 99.5446 12.6464 99.6478 12.5981C99.6566 12.5931 99.6616 12.5893 99.6528 12.566L99.6073 12.4437C99.6061 12.4399 99.6036 12.4367 99.6002 12.4347C99.5968 12.4327 99.5928 12.4321 99.5889 12.433H99.584C99.4983 12.4699 99.4053 12.487 99.3121 12.4827C99.2298 12.4861 99.1492 12.4588 99.0858 12.4062C99.0331 12.3463 99.0057 12.2683 99.0093 12.1886H99.6666C99.6689 12.1887 99.6712 12.1884 99.6734 12.1876C99.6755 12.1868 99.6775 12.1856 99.6792 12.184C99.6809 12.1825 99.6823 12.1806 99.6833 12.1785C99.6843 12.1764 99.6848 12.1741 99.6849 12.1718C99.6987 12.1668 99.7208 12.0357 99.6761 11.8912V11.8908ZM99.0239 12.0269C99.03 11.9724 99.0486 11.9201 99.0781 11.874C99.0976 11.8428 99.1251 11.8175 99.1577 11.8008C99.1904 11.784 99.2269 11.7764 99.2636 11.7788C99.3001 11.7771 99.3363 11.7848 99.369 11.8012C99.4016 11.8176 99.4294 11.8421 99.4498 11.8724C99.4772 11.919 99.4928 11.9715 99.4953 12.0254L99.0239 12.0269Z"
            fill="white"
          />
          <path
            d="M94.4171 11.8908C94.3998 11.8341 94.3703 11.7819 94.3307 11.7379C94.2966 11.6956 94.2531 11.662 94.2037 11.6396C94.143 11.615 94.078 11.6028 94.0126 11.6037C93.938 11.6019 93.8638 11.6158 93.795 11.6446C93.7372 11.6711 93.6861 11.7103 93.6455 11.7593C93.605 11.8105 93.5744 11.8689 93.5553 11.9313C93.5367 11.9993 93.5276 12.0696 93.5282 12.1401C93.5266 12.211 93.5374 12.2816 93.5599 12.3488C93.5769 12.4119 93.6097 12.4696 93.6551 12.5167C93.7021 12.5629 93.7575 12.5997 93.8184 12.6252C93.8947 12.6547 93.9765 12.6669 94.0581 12.6612C94.172 12.6681 94.2858 12.6464 94.3892 12.5981C94.398 12.5931 94.4029 12.5893 94.3938 12.566L94.3429 12.4452C94.3425 12.4433 94.3416 12.4415 94.3405 12.4399C94.3393 12.4383 94.3379 12.4369 94.3362 12.4359C94.3345 12.4349 94.3327 12.4342 94.3308 12.4339C94.3288 12.4336 94.3268 12.4336 94.3249 12.4341H94.32C94.2342 12.4707 94.1413 12.4876 94.0481 12.4834C93.9658 12.4871 93.885 12.4599 93.8218 12.4069C93.769 12.3473 93.7415 12.2694 93.7453 12.1898H94.4029C94.4076 12.1899 94.4122 12.1881 94.4156 12.1849C94.419 12.1817 94.4211 12.1773 94.4213 12.1726C94.4347 12.168 94.4572 12.0369 94.4121 11.8919L94.4171 11.8908ZM93.7599 12.0281C93.7662 11.9737 93.7848 11.9214 93.8141 11.8751C93.8337 11.844 93.8613 11.8188 93.894 11.802C93.9267 11.7853 93.9633 11.7776 94 11.7799C94.0364 11.7785 94.0727 11.7865 94.1051 11.8032C94.1376 11.8199 94.1653 11.8446 94.1854 11.8751C94.2131 11.9215 94.2287 11.9741 94.2309 12.0281H93.7599Z"
            fill="white"
          />
          <path
            d="M92.6059 11.9948C92.5787 11.9948 92.547 11.9898 92.5023 11.9898C92.4471 11.9906 92.3923 11.9982 92.339 12.0124C92.2903 12.0249 92.2443 12.0463 92.2033 12.0755C92.1627 12.1026 92.1301 12.1401 92.1089 12.184C92.0853 12.2304 92.0729 12.2816 92.0725 12.3335C92.0704 12.3854 92.0814 12.437 92.1047 12.4834C92.1242 12.5247 92.154 12.5603 92.1911 12.587C92.2319 12.6157 92.278 12.6358 92.3268 12.6463C92.3831 12.6596 92.4409 12.6658 92.4988 12.6646C92.5657 12.6654 92.6325 12.6592 92.698 12.6463C92.7611 12.6375 92.8426 12.6191 92.8659 12.6142C92.8814 12.611 92.8966 12.6065 92.9114 12.6008C92.916 12.5996 92.92 12.5967 92.9225 12.5926C92.925 12.5885 92.9258 12.5837 92.9248 12.579V11.9768C92.9293 11.9238 92.9223 11.8705 92.9044 11.8204C92.8864 11.7703 92.8579 11.7247 92.8208 11.6866C92.7335 11.6215 92.6259 11.5895 92.5172 11.5964C92.4578 11.5956 92.3985 11.6017 92.3406 11.6147C92.269 11.6273 92.2001 11.6518 92.1368 11.6874C92.1327 11.6904 92.1299 11.6949 92.129 11.7C92.128 11.705 92.129 11.7102 92.1318 11.7145L92.1773 11.8418C92.1778 11.8438 92.1787 11.8456 92.1798 11.8471C92.181 11.8487 92.1825 11.85 92.1842 11.851C92.1859 11.852 92.1878 11.8527 92.1898 11.8529C92.1917 11.8532 92.1937 11.8531 92.1956 11.8525H92.2006C92.204 11.852 92.2071 11.8504 92.2094 11.848C92.2974 11.8055 92.3935 11.7823 92.4912 11.7799C92.5485 11.7757 92.6056 11.7901 92.6541 11.8208C92.6904 11.848 92.7087 11.8885 92.7087 11.9791V12.0063L92.6059 11.9975V11.9948ZM92.3474 12.4593C92.3326 12.4487 92.3203 12.4348 92.3115 12.4188C92.2918 12.3847 92.2847 12.3447 92.2912 12.3059C92.2978 12.267 92.3177 12.2316 92.3474 12.2058C92.4035 12.1679 92.4715 12.1517 92.5386 12.1603C92.5977 12.1607 92.6568 12.1653 92.7152 12.1741V12.4731C92.657 12.4851 92.598 12.4925 92.5386 12.4953C92.4726 12.5054 92.4052 12.4927 92.3474 12.4593Z"
            fill="white"
          />
          <path
            d="M97.9051 11.6544C97.9061 11.6525 97.9066 11.6504 97.9068 11.6483C97.907 11.6461 97.9067 11.644 97.906 11.642C97.9053 11.6399 97.9043 11.6381 97.9029 11.6364C97.9014 11.6348 97.8997 11.6335 97.8978 11.6326C97.8625 11.6215 97.8258 11.6153 97.7888 11.6142C97.7316 11.6084 97.6738 11.6178 97.6214 11.6414C97.5791 11.6594 97.5417 11.6873 97.5124 11.7228V11.6414C97.5121 11.6366 97.51 11.6322 97.5066 11.6288C97.5033 11.6254 97.4988 11.6234 97.4941 11.623H97.3174C97.3127 11.6234 97.3082 11.6254 97.3048 11.6288C97.3015 11.6322 97.2994 11.6366 97.2991 11.6414V12.624C97.2994 12.6287 97.3015 12.6332 97.3048 12.6366C97.3082 12.6399 97.3127 12.642 97.3174 12.6423H97.4895C97.4942 12.642 97.4987 12.6399 97.5021 12.6366C97.5054 12.6332 97.5075 12.6287 97.5078 12.624V12.1361C97.5068 12.0781 97.5143 12.0203 97.53 11.9645C97.5404 11.9276 97.561 11.8943 97.5893 11.8685C97.6118 11.8453 97.6398 11.8282 97.6707 11.8188C97.6988 11.8105 97.7279 11.806 97.7571 11.8054C97.7816 11.8055 97.806 11.8084 97.8298 11.8142C97.8351 11.8148 97.8404 11.8132 97.8446 11.81C97.8488 11.8067 97.8515 11.8019 97.8523 11.7966C97.8657 11.7645 97.8978 11.6743 97.9066 11.6559"
            fill="white"
          />
          <path
            d="M96.2833 11.2022L96.2198 11.1884C96.19 11.183 96.1599 11.1801 96.1296 11.1796C96.0791 11.176 96.0283 11.1831 95.9807 11.2003C95.9331 11.2176 95.8896 11.2447 95.8531 11.2798C95.7813 11.3646 95.7357 11.4685 95.722 11.5788L95.7132 11.6243H95.5637C95.5584 11.6243 95.5534 11.6262 95.5492 11.6295C95.5451 11.6329 95.5423 11.6375 95.5412 11.6426L95.5186 11.7784C95.5178 11.7834 95.519 11.7886 95.5219 11.7928C95.5248 11.797 95.5293 11.7999 95.5343 11.8009H95.6872L95.5377 12.6203C95.5296 12.6759 95.5161 12.7306 95.4972 12.7835C95.4873 12.8175 95.472 12.8497 95.4517 12.8787C95.4376 12.9001 95.4167 12.9161 95.3924 12.9242C95.3677 12.9319 95.3418 12.9348 95.316 12.933C95.3022 12.933 95.28 12.9284 95.2617 12.9284C95.2491 12.9258 95.2369 12.9212 95.2257 12.9147C95.2216 12.9134 95.217 12.9135 95.2129 12.9152C95.2088 12.9167 95.2054 12.9197 95.2032 12.9234C95.1986 12.9372 95.1577 13.0458 95.1535 13.0546C95.1512 13.0594 95.1508 13.0649 95.1524 13.0699C95.1541 13.075 95.1576 13.0792 95.1623 13.0817C95.1815 13.0893 95.2013 13.0955 95.2215 13.1001C95.2527 13.1074 95.2848 13.1104 95.3167 13.1089C95.3722 13.1101 95.4275 13.1009 95.4796 13.0817C95.5267 13.0633 95.5687 13.0338 95.6019 12.9957C95.6395 12.9532 95.6688 12.904 95.6884 12.8508C95.7136 12.7784 95.7334 12.7041 95.7476 12.6287L95.896 11.7925H96.1105C96.1158 11.7925 96.1209 11.7906 96.1249 11.7873C96.129 11.784 96.1319 11.7793 96.133 11.7742L96.1556 11.6384C96.1564 11.6334 96.1552 11.6282 96.1523 11.624C96.1493 11.6198 96.1449 11.6169 96.1399 11.6159H95.9243C95.9312 11.5647 95.9441 11.5146 95.9625 11.4664C95.9714 11.4401 95.9871 11.4166 96.008 11.3983C96.0239 11.3833 96.0422 11.3711 96.0623 11.3624C96.0861 11.357 96.1105 11.354 96.1349 11.3536C96.1533 11.3536 96.1758 11.3586 96.1892 11.3586C96.2004 11.3594 96.2113 11.3624 96.2213 11.3674C96.2439 11.3719 96.2439 11.3674 96.2485 11.3586L96.2982 11.2225C96.3028 11.2137 96.2894 11.2091 96.2844 11.2041"
            fill="white"
          />
          <path
            d="M93.35 12.6241C93.3498 12.6288 93.3478 12.6333 93.3445 12.6367C93.3412 12.64 93.3368 12.6421 93.3321 12.6425H93.16C93.1553 12.6421 93.1508 12.6401 93.1474 12.6367C93.1441 12.6333 93.142 12.6289 93.1417 12.6241V11.2217C93.1419 11.2169 93.144 11.2124 93.1473 11.209C93.1507 11.2057 93.1552 11.2036 93.16 11.2034H93.3279C93.3326 11.2036 93.3371 11.2057 93.3405 11.209C93.3439 11.2124 93.3459 11.2169 93.3462 11.2217V12.6257L93.35 12.6241Z"
            fill="white"
          />
          <path
            d="M91.0736 18.1473C91.0571 18.1634 91.0399 18.1787 91.0223 18.1932V17.9504H90.8055V19.8403H91.0227V19.1471C91.3355 19.5069 91.6956 19.471 91.9285 19.3253C92.2141 19.1487 92.3364 18.7675 92.2343 18.4157C92.076 17.8977 91.4272 17.7184 91.0736 18.1473ZM91.4704 19.2179C91.1848 19.2179 91.0116 18.9732 91.0074 18.6677C91.0032 18.3622 91.2426 18.1091 91.5266 18.1068C91.8107 18.1045 92.0363 18.3446 92.0363 18.6662C92.0357 18.7391 92.0207 18.8112 91.9922 18.8784C91.9638 18.9455 91.9223 19.0064 91.8703 19.0575C91.8183 19.1087 91.7567 19.1491 91.6891 19.1764C91.6214 19.2037 91.5491 19.2174 91.4762 19.2167H91.47L91.4704 19.2179Z"
            fill="#7D888E"
          />
          <path
            d="M98.7957 17.5105V17.9387H99.2514V18.1345H98.8075C98.8045 18.1815 98.7995 18.2159 98.7995 18.2568C98.7995 18.482 98.8079 18.7076 98.7995 18.9293C98.7861 19.1943 98.9218 19.2505 99.1665 19.2016C99.1872 19.1958 99.2074 19.1893 99.2277 19.1817C99.2782 19.3472 99.2464 19.3973 99.0813 19.4183C98.7372 19.4593 98.572 19.3136 98.5712 18.9657V18.1436L98.3755 18.1345V17.9509L98.5701 17.9387V17.5105H98.7957Z"
            fill="#7D888E"
          />
          <path
            d="M94.3046 19.3919H94.0856V17.9508H94.3004V18.2835C94.4534 18.0541 94.6189 17.9099 94.8869 17.921V18.1454C94.4526 18.2265 94.3039 18.4108 94.3039 18.8608C94.3046 19.0328 94.3046 19.2076 94.3046 19.3919Z"
            fill="#7D888E"
          />
          <path
            d="M96.2306 17.3506V18.1883C95.8482 17.8465 95.5041 17.8213 95.2117 18.0923C94.9192 18.3634 94.8936 18.8509 95.1409 19.1682C95.2397 19.2965 95.3824 19.3836 95.5416 19.4129C95.8184 19.4684 96.0356 19.3602 96.2298 19.1201V19.3877H96.4397V17.3499H96.2306V17.3506ZM95.7052 19.2286C95.4196 19.2221 95.1983 18.9694 95.2044 18.6551C95.2105 18.3409 95.4238 18.105 95.714 18.1084C96.0042 18.1118 96.2367 18.3611 96.2325 18.6792C96.2302 18.982 95.9874 19.2344 95.706 19.2283L95.7052 19.2286Z"
            fill="#7D888E"
          />
          <path
            d="M93.7071 18.3788C93.6945 18.1578 93.5584 18.0118 93.347 17.9548C93.0866 17.8887 92.8111 17.9207 92.5728 18.0446L92.634 18.224C92.8901 18.1284 93.0258 18.1093 93.1933 18.1303C93.3818 18.1544 93.5489 18.3341 93.4847 18.5474L93.4185 18.5333C93.1738 18.4878 92.9322 18.4606 92.6993 18.5684C92.6279 18.5989 92.566 18.6482 92.5201 18.7109C92.4743 18.7736 92.4462 18.8476 92.4388 18.9249C92.4314 19.0023 92.445 19.0802 92.4781 19.1505C92.5112 19.2207 92.5627 19.2808 92.6271 19.3243C92.7488 19.4054 92.8948 19.4419 93.0404 19.4275C93.2158 19.4141 93.3796 19.3349 93.4992 19.2058L93.5095 19.3893H93.7148C93.7148 19.3568 93.7224 19.3281 93.7221 19.3048C93.7194 18.9959 93.7255 18.6847 93.7071 18.3788ZM93.2897 19.1886C93.1103 19.2746 92.9276 19.2876 92.7594 19.163C92.7328 19.1415 92.7108 19.1151 92.6945 19.0851C92.6782 19.0551 92.668 19.0223 92.6645 18.9883C92.6609 18.9544 92.6641 18.9201 92.6738 18.8874C92.6835 18.8547 92.6996 18.8243 92.7211 18.7978C92.7375 18.7776 92.757 18.76 92.7789 18.7458C92.9828 18.6516 93.2146 18.6369 93.4288 18.7045C93.4468 18.7127 93.4627 18.725 93.4751 18.7404C93.4875 18.7558 93.4961 18.7739 93.5003 18.7932C93.5156 18.8733 93.5027 18.9563 93.4638 19.028C93.4249 19.0997 93.3624 19.1557 93.287 19.1867L93.2897 19.1886Z"
            fill="#7D888E"
          />
          <path
            d="M97.4999 17.9071C97.3487 17.9045 97.2001 17.9469 97.073 18.0288C96.9458 18.1106 96.8458 18.2283 96.7856 18.367C96.7254 18.5057 96.7076 18.6591 96.7345 18.8079C96.7615 18.9567 96.832 19.0942 96.937 19.2029C97.0421 19.3117 97.177 19.3868 97.3248 19.4189C97.4726 19.451 97.6266 19.4385 97.7672 19.3831C97.9079 19.3277 98.029 19.2318 98.1152 19.1075C98.2014 18.9833 98.2488 18.8363 98.2515 18.6851V18.6802C98.255 18.4798 98.1789 18.2862 98.0398 18.1418C97.9008 17.9975 97.7102 17.9142 97.5098 17.9102L97.4999 17.9071ZM97.4999 19.2334C97.202 19.2334 96.9646 18.9822 96.9673 18.663C96.9699 18.3437 97.1967 18.1059 97.4972 18.1082C97.7977 18.1105 98.0275 18.3579 98.0275 18.6702C98.0275 18.9826 97.7958 19.2323 97.4991 19.2334H97.4999Z"
            fill="#7D888E"
          />
          <g style={{ mixBlendMode: 'color' }} filter="url(#filter7_d_11_3874)">
            <rect
              width="23.5043"
              height="23.5043"
              rx="11.7522"
              transform="matrix(1 0 0 -1 83.7052 25.7529)"
              fill="white"
            />
            <rect
              x="0.489673"
              y="-0.489673"
              width="22.525"
              height="22.525"
              rx="11.2625"
              transform="matrix(1 0 0 -1 83.7052 24.7736)"
              stroke="#DDDDE0"
              strokeWidth="0.979346"
            />
          </g>
        </g>
        <rect
          x="0.489673"
          y="-0.489673"
          width="22.525"
          height="22.525"
          rx="11.2625"
          transform="matrix(1 0 0 -1 83.6506 24.7736)"
          stroke="#DDDDE0"
          strokeWidth="0.979346"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_11_3874"
          x="0.504122"
          y="0.387778"
          width="33.1019"
          height="33.102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.93804" />
          <feGaussianBlur stdDeviation="2.3994" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3874"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3874"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_11_3874"
          x="-7.85406"
          y="-9.49993"
          width="49.9238"
          height="49.9238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.7535"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_11_3874"
          />
          <feOffset dy="1.46125" />
          <feGaussianBlur stdDeviation="5.72811" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.372549 0 0 0 0 0.356863 0 0 0 0 0.968627 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3874"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3874"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_11_3874"
          x="26.62"
          y="0.387778"
          width="33.1019"
          height="33.102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.93804" />
          <feGaussianBlur stdDeviation="2.3994" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3874"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3874"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_11_3874"
          x="18.2637"
          y="-9.49993"
          width="49.9238"
          height="49.9238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.7535"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_11_3874"
          />
          <feOffset dy="1.46125" />
          <feGaussianBlur stdDeviation="5.72811" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.372549 0 0 0 0 0.356863 0 0 0 0 0.968627 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3874"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3874"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_11_3874"
          x="52.7359"
          y="0.387778"
          width="33.1019"
          height="33.102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.93804" />
          <feGaussianBlur stdDeviation="2.3994" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3874"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3874"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_11_3874"
          x="44.3796"
          y="-9.49993"
          width="49.9237"
          height="49.9238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.7535"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_11_3874"
          />
          <feOffset dy="1.46125" />
          <feGaussianBlur stdDeviation="5.72811" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.372549 0 0 0 0 0.356863 0 0 0 0 0.968627 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3874"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3874"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_11_3874"
          x="78.8518"
          y="0.387778"
          width="33.1019"
          height="33.102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.93804" />
          <feGaussianBlur stdDeviation="2.3994" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3874"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3874"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_11_3874"
          x="70.4955"
          y="-9.49993"
          width="49.9237"
          height="49.9238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.7535"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_11_3874"
          />
          <feOffset dy="1.46125" />
          <feGaussianBlur stdDeviation="5.72811" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.372549 0 0 0 0 0.356863 0 0 0 0 0.968627 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3874"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3874"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_11_3874">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 5.30292 25.7529)"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_11_3874">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 31.4188 25.7529)"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip2_11_3874">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 57.5347 25.7529)"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip3_11_3874">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 83.6506 25.7529)"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
